import { useRef, useState, MouseEvent, useEffect } from "react";
import { getCalendarInf, getDateInf, getDatesRange } from "./action";
import { useBookInfContext } from "components/context/bookInfContext";
import CalendarDay from "./calendarDay";
import i18n from "locales/i18n";
import { useTranslation } from "react-i18next";
import { alertControl, diffDate } from "util/commAction";
import "./calendar.scss";

type IProsp = {
  now: Date;
  styles: string;
};

type directionTyp = "up" | "down";

export function CalendarPicker({ now, styles }: IProsp) {
  const { t } = useTranslation();
  const langCd = i18n.language;

  const spanRef = useRef<HTMLSpanElement>(null);
  const { dates, setDates, dateRange, setDateRange, bookInf, onBookInf } =
    useBookInfContext();

  const [monthDate, setMonthDate] = useState<any[]>([]);
  const { today } = getDateInf(new Date());

  const nowyear = now.toLocaleDateString(langCd, { year: "numeric" });
  const nowMonth = now.toLocaleDateString(langCd, { month: "2-digit" });

  const handleSelectDate = ({
    event,
    date,
  }: {
    event: MouseEvent<HTMLLIElement, globalThis.MouseEvent>;
    date: any;
  }) => {
    if (dates.length === 1 && dates.includes(date.dateSt)) {
      alertControl({
        isOpen: true,
        inner: t("alr_selected_data"),
      });

      return;
    }

    setDates(dates.concat(date.dateSt));
    onBookInf({
      dates: dates.concat(date.dateSt),
    });

    if (dates.length === 1 || bookInf.dates.length === 1) {
      //date range
      let direction = (dates[0] > date.dateSt ? "up" : "down") as directionTyp;

      direction === "up"
        ? setDates(dates.concat(date.dateSt).reverse())
        : setDates(dates.concat(date.dateSt));

      // direction === "up"
      //   ? onBookInf({
      //       dates: dates.concat(date.dateSt).reverse(),
      //     })
      //   : onBookInf({
      //       dates: dates.concat(date.dateSt),
      //     });

      let range = getDatesRange({
        startDateStr: dates[0],
        endDateStr: date.dateSt,
        direction: direction,
      });

      const diff = diffDate([bookInf.dates[0], date.dateSt]);

      if (range) {
        if (range.length > 90) {
          return alertControl({
            isOpen: true,
            inner: t("alr_slct_max_date"),
          });
        }
        setDateRange(dateRange.concat(range));
        onBookInf({
          dates:
            direction === "up"
              ? dates.concat(date.dateSt).reverse()
              : dates.concat(date.dateSt),
          dateLength: diff,
          dateRange: dateRange.concat(range),
        });
      }
    }
    if (dates.length === 2 || bookInf.dates.length === 2) {
      // 세번째 클릭
      setDates([date.dateSt]);
      setDateRange([]);
      onBookInf({
        ...bookInf,
        dates: [date.dateSt],
        dateRange: [],
        dateLength: 1,
      });
    }
  };

  //GET MONTH DATE
  useEffect(() => {
    const { monthDate } = getCalendarInf({ now });
    if (monthDate) {
      setMonthDate(monthDate);
    }
  }, [now]);

  useEffect(() => {
    if (bookInf?.dates.length === 2) {
      const range = getDatesRange({
        startDateStr: bookInf?.dates[0],
        endDateStr: bookInf?.dates[1],
        direction: "down",
      });

      onBookInf({
        dateRange: range,
        dateLength: (range && range?.length - 1) ?? 1,
      });
    }
  }, []);

  return (
    <div className={styles}>
      <h3 className="">
        {nowyear}
        {langCd === "en" ? " ." : " "}
        {nowMonth}
      </h3>
      <div className="calendar">
        <CalendarDay />
        <ul className="month-date">
          {monthDate.map((date, index) => {
            // const isStart =
            //   (dates[0] || bookInf?.dates[0]) === date.dateSt && !date.isLdate;
            // const isLast =
            //   (dates[1] || bookInf?.dates[1]) === date.dateSt && !date.isFdate;

            const isStart = (dates[0] || bookInf?.dates[0]) === date.dateSt;
            const isLast = (dates[1] || bookInf?.dates[1]) === date.dateSt;

            const isRange = (
              dateRange.includes(date.dateSt) ||
              bookInf?.dateRange.includes(date.dateSt)
            ).toString();

            return (
              <li
                key={index}
                data-datest={date.dateSt + ""}
                is-start={isStart.toString()}
                is-end={isLast.toString()}
                is-last-month={date.isLast + ""}
                // is-range={dateRange.includes(date.dateSt).toString()}
                is-range={isRange}
                week-start={date.isWeekStart + ""}
                week-end={date.isWeekEnd + ""}
                month-start={date.isFdate + ""}
                month-end={date.isLdate + ""}
                onClick={(e) => handleSelectDate({ event: e, date })}
                // onMouseOver={(e) => {
                //   if (dates.length === 1) {
                //     const direction =
                //       Number(dates[0]) > Number(date.dateSt) ? "up" : "down";
                //     let dateRange = getDatesRange({
                //       startDateStr: dates[0],
                //       endDateStr: date.dateSt,
                //       direction,
                //     });
                //     if (dateRange) {
                //       setDateRange(dateRange);
                //     }
                //   }
                // }}
              >
                <span
                  ref={spanRef}
                  // is-start={(dates[0] === date.dateSt).toString()}
                  // is-end={(dates[1] === date.dateSt).toString()}
                  // is-range={dateRange.includes(date.dateSt).toString()}
                  is-start={isStart.toString()}
                  is-end={isLast.toString()}
                  is-range={isRange}
                  week-start={date.isWeekStart + ""}
                  week-end={date.isWeekEnd + ""}
                  data-datest={date.dateSt + ""}
                  is-today={(date.dateSt === today) + ""}
                >
                  {date.date}
                </span>
                <sub is-today={(date.dateSt === today) + ""}>
                  {t("lbl_hm_tdy")}
                </sub>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
